import React, { useState, createContext } from 'react'

export const AppControlContext = createContext();
/*
export const AppControlContext = createContext({
  isAppControl: false,
  setIsAppControl: () => {},
});
*/
export const AppControlContextProvider = (props) => {
  const [isAppControl, setIsAppControl] = useState(false);

  return (
    <AppControlContext.Provider
      value={{
        isAppControl, setIsAppControl,
      }}
    >
      {props.children}
    </AppControlContext.Provider>
  )
}